"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Answer = void 0;
const FormQuestionType_1 = __importDefault(require("@opsbase/lib-form/FormQuestionType"));
const Chip_1 = __importDefault(require("@opsbase/web-chips/Chip"));
const react_1 = __importDefault(require("react"));
const AnswerCheck_1 = __importDefault(require("../answertypes/AnswerCheck"));
const AnswerDateTime_1 = __importDefault(require("../answertypes/AnswerDateTime"));
const AnswerList_1 = __importDefault(require("../answertypes/AnswerList"));
const AnswerNumber_1 = __importDefault(require("../answertypes/AnswerNumber"));
const AnswerPhoto_1 = __importDefault(require("../answertypes/AnswerPhoto"));
const AnswerRating_1 = __importDefault(require("../answertypes/AnswerRating"));
const AnswerSPT_1 = __importDefault(require("../answertypes/AnswerSPT"));
const AnswerText_1 = __importDefault(require("../answertypes/AnswerText"));
exports.Answer = react_1.default.memo((props) => {
    const { form, questionNodeId } = props;
    const question = form.questions[questionNodeId];
    const answer = form.answers[questionNodeId];
    if (!answer)
        return null;
    if (answer.value === '' && answer.photos === '' && !answer.notApplicable)
        return null;
    if (answer.notApplicable) {
        return react_1.default.createElement(Chip_1.default, { label: 'N/A' });
    }
    switch (question.type) {
        case FormQuestionType_1.default.CHECK:
            return react_1.default.createElement(AnswerCheck_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.LIST:
            return react_1.default.createElement(AnswerList_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.RATING:
            return react_1.default.createElement(AnswerRating_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.NUMBER:
            return react_1.default.createElement(AnswerNumber_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.TEXT:
        case FormQuestionType_1.default.ISSUE:
            return react_1.default.createElement(AnswerText_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.SPT:
        case FormQuestionType_1.default.ASSET:
            return react_1.default.createElement(AnswerSPT_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.DATETIME:
            return react_1.default.createElement(AnswerDateTime_1.default, Object.assign({}, props));
        case FormQuestionType_1.default.PHOTO:
        case FormQuestionType_1.default.SIGNATURE:
            return react_1.default.createElement(AnswerPhoto_1.default, Object.assign({}, props));
        // -----------------
        // PAUSE DEPRECATION
        // case FormQuestionType.PAUSE:
        // 	return <AnswerPause {...props} />
        // -----------------
    }
    return null;
});
exports.default = exports.Answer;
